import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import { DateFilterProvider } from "@/context/DateFilterContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import Pipeline from "@/pages/Pipeline";
import Benchmarks from "@/pages/Benchmarks";
import Services from "@/pages/Services";
import Archived from "@/pages/Archived";
import ResearchTopics from "@/pages/ResearchTopics";
import Settings from "@/pages/Settings";

function LandingGate() {
  const { settings, loaded } = useSettings();
  const nav = useNavigate();
  const loc = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (done.current || !loaded) return;
    done.current = true;
    if (sessionStorage.getItem("rnd_landed")) return;
    sessionStorage.setItem("rnd_landed", "1");
    const dl = settings.default_landing;
    if (dl && dl !== "/" && loc.pathname === "/") nav(dl, { replace: true });
  }, [loaded, settings, nav, loc.pathname]);
  return null;
}

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-muted-foreground">Loading...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <SettingsProvider>
      <DateFilterProvider>
        <LandingGate />
        <Layout><Outlet /></Layout>
      </DateFilterProvider>
    </SettingsProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/benchmarks" element={<Benchmarks />} />
        <Route path="/services" element={<Services />} />
        <Route path="/research" element={<ResearchTopics />} />
        <Route path="/archived" element={<Archived />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
